// Copyright 2025, compose-coui-ui contributors
// SPDX-License-Identifier: Apache-2.0

package io.github.suqi8.coui.kmp.icon.extended

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathNode
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.unit.dp
import io.github.suqi8.coui.kmp.icon.COUIIcons

val COUIIcons.Settings: ImageVector
    get() = COUIIcons.Regular.Settings

val COUIIcons.Light.Settings: ImageVector
    get() {
        if (_settingsLight != null) return _settingsLight!!
        _settingsLight = ImageVector.Builder(
            name = "Settings.Light",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1208.4f,
            viewportHeight = 1208.4f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1208.4f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(625.2f, 105.7f),
                        PathNode.QuadTo(634.2f, 106.7f, 645.7f, 112.7f),
                        PathNode.QuadTo(657.2f, 118.7f, 672.2f, 127.7f),
                        PathNode.LineTo(690.2f, 137.7f),
                        PathNode.LineTo(971.2f, 295.7f),
                        PathNode.QuadTo(995.2f, 308.7f, 1010.7f, 318.7f),
                        PathNode.QuadTo(1026.2f, 328.7f, 1033.9f, 336.6f),
                        PathNode.QuadTo(1049.2f, 351.7f, 1057.2f, 374.7f),
                        PathNode.QuadTo(1060.2f, 386.7f, 1061.2f, 404.7f),
                        PathNode.QuadTo(1062.2f, 422.7f, 1062.2f, 449.7f),
                        PathNode.VerticalTo(758.7f),
                        PathNode.QuadTo(1062.2f, 784.7f, 1061.2f, 802.7f),
                        PathNode.QuadTo(1060.2f, 820.7f, 1056.6f, 832.4f),
                        PathNode.QuadTo(1050.2f, 854.7f, 1035.2f, 870.7f),
                        PathNode.QuadTo(1027.2f, 878.7f, 1014.7f, 886.7f),
                        PathNode.QuadTo(1002.2f, 894.7f, 983.2f, 904.7f),
                        PathNode.LineTo(971.2f, 911.7f),
                        PathNode.LineTo(690.2f, 1070.7f),
                        PathNode.QuadTo(663.2f, 1086.7f, 649.7f, 1093.2f),
                        PathNode.QuadTo(636.2f, 1099.7f, 625.5f, 1101.7f),
                        PathNode.QuadTo(604.2f, 1107.7f, 582.9f, 1101.7f),
                        PathNode.QuadTo(572.2f, 1099.7f, 558.7f, 1093.2f),
                        PathNode.QuadTo(545.2f, 1086.7f, 518.2f, 1070.7f),
                        PathNode.LineTo(237.2f, 911.7f),
                        PathNode.QuadTo(228.2f, 906.7f, 218.2f, 900.7f),
                        PathNode.QuadTo(203.2f, 892.7f, 191.7f, 885.2f),
                        PathNode.QuadTo(180.2f, 877.7f, 173.2f, 870.7f),
                        PathNode.QuadTo(157.2f, 851.7f, 152.2f, 832.7f),
                        PathNode.QuadTo(148.2f, 820.7f, 147.2f, 802.7f),
                        PathNode.QuadTo(146.2f, 784.7f, 146.2f, 758.7f),
                        PathNode.VerticalTo(449.7f),
                        PathNode.QuadTo(146.2f, 422.7f, 147.2f, 404.7f),
                        PathNode.QuadTo(148.2f, 386.7f, 152.2f, 374.7f),
                        PathNode.QuadTo(158.2f, 352.7f, 174.1f, 336.4f),
                        PathNode.QuadTo(181.2f, 328.7f, 194.9f, 320.3f),
                        PathNode.QuadTo(208.6f, 311.9f, 227.2f, 301.7f),
                        PathNode.LineTo(237.2f, 295.7f),
                        PathNode.LineTo(518.2f, 137.7f),
                        PathNode.LineTo(536.2f, 127.7f),
                        PathNode.QuadTo(551.2f, 118.7f, 562.7f, 112.7f),
                        PathNode.QuadTo(574.2f, 106.7f, 583.0f, 105.7f),
                        PathNode.QuadTo(604.1f, 100.7f, 625.2f, 105.7f),
                        PathNode.Close,
                        PathNode.MoveTo(206.2f, 421.7f),
                        PathNode.VerticalTo(791.7f),
                        PathNode.QuadTo(206.2f, 812.7f, 213.2f, 824.2f),
                        PathNode.QuadTo(220.2f, 835.7f, 240.2f, 847.7f),
                        PathNode.LineTo(571.2f, 1033.7f),
                        PathNode.QuadTo(590.2f, 1043.7f, 603.2f, 1044.2f),
                        PathNode.QuadTo(616.2f, 1044.7f, 634.2f, 1034.7f),
                        PathNode.LineTo(963.2f, 850.7f),
                        PathNode.QuadTo(988.2f, 836.7f, 995.7f, 822.7f),
                        PathNode.QuadTo(1003.2f, 808.7f, 1003.2f, 779.0f),
                        PathNode.VerticalTo(421.7f),
                        PathNode.QuadTo(1003.2f, 399.7f, 997.2f, 387.2f),
                        PathNode.QuadTo(991.2f, 374.7f, 976.2f, 365.7f),
                        PathNode.LineTo(641.2f, 176.7f),
                        PathNode.QuadTo(619.2f, 163.7f, 604.7f, 163.7f),
                        PathNode.QuadTo(590.2f, 163.7f, 567.2f, 176.7f),
                        PathNode.LineTo(243.2f, 358.7f),
                        PathNode.QuadTo(221.2f, 371.7f, 213.7f, 384.2f),
                        PathNode.QuadTo(206.2f, 396.7f, 206.2f, 421.7f),
                        PathNode.Close,
                        PathNode.MoveTo(790.2f, 603.6f),
                        PathNode.QuadTo(790.2f, 654.7f, 765.1f, 697.1f),
                        PathNode.QuadTo(740.0f, 739.4f, 697.8f, 764.6f),
                        PathNode.QuadTo(655.5f, 789.7f, 604.4f, 789.7f),
                        PathNode.QuadTo(554.2f, 789.7f, 511.4f, 764.6f),
                        PathNode.QuadTo(468.5f, 739.5f, 443.4f, 697.3f),
                        PathNode.QuadTo(418.2f, 655.0f, 418.2f, 603.9f),
                        PathNode.QuadTo(418.2f, 553.7f, 443.3f, 510.9f),
                        PathNode.QuadTo(468.4f, 468.0f, 511.1f, 442.9f),
                        PathNode.QuadTo(553.9f, 417.7f, 604.1f, 417.7f),
                        PathNode.QuadTo(655.2f, 417.7f, 697.6f, 442.8f),
                        PathNode.QuadTo(739.9f, 467.9f, 765.1f, 510.6f),
                        PathNode.QuadTo(790.2f, 553.4f, 790.2f, 603.6f),
                        PathNode.Close,
                        PathNode.MoveTo(478.2f, 603.8f),
                        PathNode.QuadTo(478.2f, 656.7f, 515.4f, 693.2f),
                        PathNode.QuadTo(552.5f, 729.7f, 604.3f, 729.7f),
                        PathNode.QuadTo(657.2f, 729.7f, 693.7f, 693.1f),
                        PathNode.QuadTo(730.2f, 656.5f, 730.2f, 603.5f),
                        PathNode.QuadTo(730.2f, 551.7f, 693.6f, 514.7f),
                        PathNode.QuadTo(657.0f, 477.7f, 604.0f, 477.7f),
                        PathNode.QuadTo(552.2f, 477.7f, 515.2f, 514.9f),
                        PathNode.QuadTo(478.2f, 552.0f, 478.2f, 603.8f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _settingsLight!!
    }

private var _settingsLight: ImageVector? = null

val COUIIcons.Normal.Settings: ImageVector
    get() {
        if (_settingsNormal != null) return _settingsNormal!!
        _settingsNormal = ImageVector.Builder(
            name = "Settings.Normal",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1229.8f,
            viewportHeight = 1229.8f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1229.8f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(638.0f, 107.5f),
                        PathNode.QuadTo(647.7f, 109.2f, 660.2f, 115.2f),
                        PathNode.QuadTo(672.7f, 121.2f, 687.7f, 130.2f),
                        PathNode.LineTo(705.7f, 140.2f),
                        PathNode.LineTo(986.7f, 298.2f),
                        PathNode.QuadTo(1014.9f, 313.9f, 1029.0f, 322.9f),
                        PathNode.QuadTo(1043.1f, 331.9f, 1051.7f, 341.2f),
                        PathNode.QuadTo(1068.9f, 359.0f, 1076.2f, 382.7f),
                        PathNode.QuadTo(1079.9f, 394.7f, 1080.9f, 414.0f),
                        PathNode.QuadTo(1081.9f, 433.4f, 1081.9f, 460.4f),
                        PathNode.VerticalTo(769.4f),
                        PathNode.QuadTo(1081.9f, 796.1f, 1080.9f, 815.1f),
                        PathNode.QuadTo(1079.9f, 834.2f, 1076.0f, 846.1f),
                        PathNode.QuadTo(1069.2f, 868.9f, 1052.1f, 888.3f),
                        PathNode.QuadTo(1044.1f, 897.0f, 1030.9f, 905.3f),
                        PathNode.QuadTo(1017.7f, 913.7f, 998.7f, 923.7f),
                        PathNode.LineTo(986.7f, 930.7f),
                        PathNode.LineTo(705.7f, 1089.7f),
                        PathNode.QuadTo(682.2f, 1103.6f, 665.9f, 1111.5f),
                        PathNode.QuadTo(649.7f, 1119.4f, 638.1f, 1121.4f),
                        PathNode.QuadTo(614.9f, 1127.4f, 591.8f, 1121.4f),
                        PathNode.QuadTo(580.2f, 1119.4f, 563.9f, 1111.5f),
                        PathNode.QuadTo(547.7f, 1103.6f, 524.1f, 1089.7f),
                        PathNode.LineTo(243.1f, 930.7f),
                        PathNode.QuadTo(235.5f, 926.4f, 226.9f, 921.7f),
                        PathNode.QuadTo(210.5f, 912.4f, 197.6f, 904.2f),
                        PathNode.QuadTo(184.7f, 896.0f, 177.7f, 888.3f),
                        PathNode.QuadTo(160.4f, 867.9f, 154.0f, 846.2f),
                        PathNode.QuadTo(150.0f, 834.2f, 149.0f, 815.1f),
                        PathNode.QuadTo(148.0f, 796.1f, 148.0f, 769.4f),
                        PathNode.VerticalTo(460.4f),
                        PathNode.QuadTo(148.0f, 433.4f, 149.0f, 414.0f),
                        PathNode.QuadTo(150.0f, 394.7f, 154.0f, 382.7f),
                        PathNode.QuadTo(160.7f, 359.3f, 178.0f, 341.1f),
                        PathNode.QuadTo(185.7f, 332.5f, 199.6f, 323.7f),
                        PathNode.QuadTo(213.6f, 314.9f, 232.4f, 304.2f),
                        PathNode.LineTo(243.1f, 298.2f),
                        PathNode.LineTo(524.1f, 140.2f),
                        PathNode.LineTo(542.1f, 130.2f),
                        PathNode.QuadTo(557.1f, 121.2f, 569.6f, 115.2f),
                        PathNode.QuadTo(582.2f, 109.2f, 591.8f, 107.5f),
                        PathNode.QuadTo(614.9f, 102.5f, 638.0f, 107.5f),
                        PathNode.Close,
                        PathNode.MoveTo(225.9f, 433.1f),
                        PathNode.VerticalTo(802.4f),
                        PathNode.QuadTo(225.9f, 818.6f, 232.5f, 829.4f),
                        PathNode.QuadTo(239.2f, 840.2f, 255.7f, 850.2f),
                        PathNode.LineTo(582.6f, 1034.1f),
                        PathNode.QuadTo(601.6f, 1044.8f, 613.6f, 1045.3f),
                        PathNode.QuadTo(625.5f, 1045.8f, 642.9f, 1036.5f),
                        PathNode.LineTo(965.7f, 855.2f),
                        PathNode.QuadTo(990.7f, 841.2f, 997.8f, 828.6f),
                        PathNode.QuadTo(1005.0f, 816.0f, 1005.0f, 786.8f),
                        PathNode.VerticalTo(435.2f),
                        PathNode.QuadTo(1005.0f, 415.2f, 999.7f, 403.4f),
                        PathNode.QuadTo(994.4f, 391.6f, 980.0f, 383.3f),
                        PathNode.LineTo(648.5f, 195.7f),
                        PathNode.QuadTo(628.5f, 184.0f, 615.4f, 184.0f),
                        PathNode.QuadTo(602.3f, 184.0f, 581.4f, 195.7f),
                        PathNode.LineTo(258.7f, 377.7f),
                        PathNode.QuadTo(239.5f, 388.6f, 232.7f, 399.7f),
                        PathNode.QuadTo(225.9f, 410.9f, 225.9f, 433.1f),
                        PathNode.Close,
                        PathNode.MoveTo(810.5f, 614.4f),
                        PathNode.QuadTo(810.5f, 668.2f, 784.1f, 712.7f),
                        PathNode.QuadTo(757.7f, 757.2f, 713.3f, 783.6f),
                        PathNode.QuadTo(668.8f, 810.0f, 615.0f, 810.0f),
                        PathNode.QuadTo(562.2f, 810.0f, 517.2f, 783.6f),
                        PathNode.QuadTo(472.1f, 757.2f, 445.7f, 712.8f),
                        PathNode.QuadTo(419.3f, 668.3f, 419.3f, 614.5f),
                        PathNode.QuadTo(419.3f, 561.7f, 445.7f, 516.7f),
                        PathNode.QuadTo(472.1f, 471.6f, 517.1f, 445.2f),
                        PathNode.QuadTo(562.1f, 418.8f, 614.9f, 418.8f),
                        PathNode.QuadTo(668.7f, 418.8f, 713.2f, 445.2f),
                        PathNode.QuadTo(757.7f, 471.6f, 784.1f, 516.6f),
                        PathNode.QuadTo(810.5f, 561.6f, 810.5f, 614.4f),
                        PathNode.Close,
                        PathNode.MoveTo(498.5f, 614.5f),
                        PathNode.QuadTo(498.5f, 663.3f, 532.8f, 697.0f),
                        PathNode.QuadTo(567.1f, 730.8f, 615.0f, 730.8f),
                        PathNode.QuadTo(663.8f, 730.8f, 697.5f, 697.0f),
                        PathNode.QuadTo(731.3f, 663.2f, 731.3f, 614.4f),
                        PathNode.QuadTo(731.3f, 566.5f, 697.5f, 532.3f),
                        PathNode.QuadTo(663.7f, 498.0f, 614.9f, 498.0f),
                        PathNode.QuadTo(567.0f, 498.0f, 532.8f, 532.3f),
                        PathNode.QuadTo(498.5f, 566.6f, 498.5f, 614.5f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _settingsNormal!!
    }

private var _settingsNormal: ImageVector? = null

val COUIIcons.Regular.Settings: ImageVector
    get() {
        if (_settingsRegular != null) return _settingsRegular!!
        _settingsRegular = ImageVector.Builder(
            name = "Settings.Regular",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1239.6f,
            viewportHeight = 1239.6f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1239.6f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(643.8f, 108.3f),
                        PathNode.QuadTo(653.8f, 110.3f, 666.8f, 116.3f),
                        PathNode.QuadTo(679.8f, 122.3f, 694.8f, 131.3f),
                        PathNode.LineTo(712.8f, 141.3f),
                        PathNode.LineTo(993.8f, 299.3f),
                        PathNode.QuadTo(1023.8f, 316.3f, 1037.3f, 324.8f),
                        PathNode.QuadTo(1050.8f, 333.3f, 1059.8f, 343.3f),
                        PathNode.QuadTo(1077.8f, 362.3f, 1084.8f, 386.3f),
                        PathNode.QuadTo(1088.8f, 398.3f, 1089.8f, 418.3f),
                        PathNode.QuadTo(1090.8f, 438.3f, 1090.8f, 465.3f),
                        PathNode.VerticalTo(774.3f),
                        PathNode.QuadTo(1090.8f, 801.3f, 1089.8f, 820.8f),
                        PathNode.QuadTo(1088.8f, 840.3f, 1084.8f, 852.3f),
                        PathNode.QuadTo(1077.8f, 875.3f, 1059.8f, 896.3f),
                        PathNode.QuadTo(1051.8f, 905.3f, 1038.3f, 913.8f),
                        PathNode.QuadTo(1024.8f, 922.3f, 1005.8f, 932.3f),
                        PathNode.LineTo(993.8f, 939.3f),
                        PathNode.LineTo(712.8f, 1098.3f),
                        PathNode.QuadTo(690.8f, 1111.3f, 673.3f, 1119.8f),
                        PathNode.QuadTo(655.8f, 1128.3f, 643.8f, 1130.3f),
                        PathNode.QuadTo(619.8f, 1136.3f, 595.8f, 1130.3f),
                        PathNode.QuadTo(583.8f, 1128.3f, 566.3f, 1119.8f),
                        PathNode.QuadTo(548.8f, 1111.3f, 526.8f, 1098.3f),
                        PathNode.LineTo(245.8f, 939.3f),
                        PathNode.QuadTo(238.8f, 935.3f, 230.8f, 931.3f),
                        PathNode.QuadTo(213.8f, 921.3f, 200.3f, 912.8f),
                        PathNode.QuadTo(186.8f, 904.3f, 179.8f, 896.3f),
                        PathNode.QuadTo(161.8f, 875.3f, 154.8f, 852.3f),
                        PathNode.QuadTo(150.8f, 840.3f, 149.8f, 820.8f),
                        PathNode.QuadTo(148.8f, 801.3f, 148.8f, 774.3f),
                        PathNode.VerticalTo(465.3f),
                        PathNode.QuadTo(148.8f, 438.3f, 149.8f, 418.3f),
                        PathNode.QuadTo(150.8f, 398.3f, 154.8f, 386.3f),
                        PathNode.QuadTo(161.8f, 362.3f, 179.8f, 343.3f),
                        PathNode.QuadTo(187.8f, 334.3f, 201.8f, 325.3f),
                        PathNode.QuadTo(215.8f, 316.3f, 234.8f, 305.3f),
                        PathNode.LineTo(245.8f, 299.3f),
                        PathNode.LineTo(526.8f, 141.3f),
                        PathNode.LineTo(544.8f, 131.3f),
                        PathNode.QuadTo(559.8f, 122.3f, 572.8f, 116.3f),
                        PathNode.QuadTo(585.8f, 110.3f, 595.8f, 108.3f),
                        PathNode.QuadTo(619.8f, 103.3f, 643.8f, 108.3f),
                        PathNode.Close,
                        PathNode.MoveTo(234.8f, 438.3f),
                        PathNode.VerticalTo(807.3f),
                        PathNode.QuadTo(234.8f, 821.3f, 241.3f, 831.8f),
                        PathNode.QuadTo(247.8f, 842.3f, 262.8f, 851.3f),
                        PathNode.LineTo(587.8f, 1034.3f),
                        PathNode.QuadTo(606.8f, 1045.3f, 618.3f, 1045.8f),
                        PathNode.QuadTo(629.8f, 1046.3f, 646.8f, 1037.3f),
                        PathNode.LineTo(966.8f, 857.3f),
                        PathNode.QuadTo(991.8f, 843.3f, 998.8f, 831.3f),
                        PathNode.QuadTo(1005.8f, 819.3f, 1005.8f, 790.3f),
                        PathNode.VerticalTo(441.3f),
                        PathNode.QuadTo(1005.8f, 422.3f, 1000.8f, 410.8f),
                        PathNode.QuadTo(995.8f, 399.3f, 981.8f, 391.3f),
                        PathNode.LineTo(651.8f, 204.3f),
                        PathNode.QuadTo(632.8f, 193.3f, 620.3f, 193.3f),
                        PathNode.QuadTo(607.8f, 193.3f, 587.8f, 204.3f),
                        PathNode.LineTo(265.8f, 386.3f),
                        PathNode.QuadTo(247.8f, 396.3f, 241.3f, 406.8f),
                        PathNode.QuadTo(234.8f, 417.3f, 234.8f, 438.3f),
                        PathNode.Close,
                        PathNode.MoveTo(819.8f, 619.3f),
                        PathNode.QuadTo(819.8f, 674.3f, 792.8f, 719.8f),
                        PathNode.QuadTo(765.8f, 765.3f, 720.3f, 792.3f),
                        PathNode.QuadTo(674.8f, 819.3f, 619.8f, 819.3f),
                        PathNode.QuadTo(565.8f, 819.3f, 519.8f, 792.3f),
                        PathNode.QuadTo(473.8f, 765.3f, 446.8f, 719.8f),
                        PathNode.QuadTo(419.8f, 674.3f, 419.8f, 619.3f),
                        PathNode.QuadTo(419.8f, 565.3f, 446.8f, 519.3f),
                        PathNode.QuadTo(473.8f, 473.3f, 519.8f, 446.3f),
                        PathNode.QuadTo(565.8f, 419.3f, 619.8f, 419.3f),
                        PathNode.QuadTo(674.8f, 419.3f, 720.3f, 446.3f),
                        PathNode.QuadTo(765.8f, 473.3f, 792.8f, 519.3f),
                        PathNode.QuadTo(819.8f, 565.3f, 819.8f, 619.3f),
                        PathNode.Close,
                        PathNode.MoveTo(507.8f, 619.3f),
                        PathNode.QuadTo(507.8f, 666.3f, 540.8f, 698.8f),
                        PathNode.QuadTo(573.8f, 731.3f, 619.8f, 731.3f),
                        PathNode.QuadTo(666.8f, 731.3f, 699.3f, 698.8f),
                        PathNode.QuadTo(731.8f, 666.3f, 731.8f, 619.3f),
                        PathNode.QuadTo(731.8f, 573.3f, 699.3f, 540.3f),
                        PathNode.QuadTo(666.8f, 507.3f, 619.8f, 507.3f),
                        PathNode.QuadTo(573.8f, 507.3f, 540.8f, 540.3f),
                        PathNode.QuadTo(507.8f, 573.3f, 507.8f, 619.3f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _settingsRegular!!
    }

private var _settingsRegular: ImageVector? = null

val COUIIcons.Medium.Settings: ImageVector
    get() {
        if (_settingsMedium != null) return _settingsMedium!!
        _settingsMedium = ImageVector.Builder(
            name = "Settings.Medium",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1260.1f,
            viewportHeight = 1260.1f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1260.1f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(655.8f, 110.6f),
                        PathNode.QuadTo(666.4f, 112.6f, 680.0f, 118.9f),
                        PathNode.QuadTo(693.6f, 125.2f, 709.2f, 134.2f),
                        PathNode.LineTo(727.2f, 144.2f),
                        PathNode.LineTo(1008.2f, 302.2f),
                        PathNode.QuadTo(1038.7f, 319.2f, 1052.5f, 328.3f),
                        PathNode.QuadTo(1066.3f, 337.4f, 1075.9f, 347.9f),
                        PathNode.QuadTo(1094.5f, 367.5f, 1102.7f, 393.9f),
                        PathNode.QuadTo(1107.3f, 407.1f, 1108.3f, 425.0f),
                        PathNode.QuadTo(1109.3f, 442.9f, 1109.3f, 475.2f),
                        PathNode.VerticalTo(784.2f),
                        PathNode.QuadTo(1109.3f, 816.5f, 1108.3f, 834.0f),
                        PathNode.QuadTo(1107.3f, 851.4f, 1102.7f, 864.6f),
                        PathNode.QuadTo(1094.5f, 889.9f, 1075.9f, 911.5f),
                        PathNode.QuadTo(1067.9f, 921.1f, 1054.7f, 929.3f),
                        PathNode.QuadTo(1041.5f, 937.5f, 1020.2f, 949.3f),
                        PathNode.LineTo(1008.2f, 956.3f),
                        PathNode.LineTo(727.2f, 1115.3f),
                        PathNode.QuadTo(699.9f, 1131.2f, 684.4f, 1138.6f),
                        PathNode.QuadTo(669.0f, 1145.9f, 655.8f, 1147.9f),
                        PathNode.QuadTo(630.0f, 1155.1f, 604.3f, 1147.9f),
                        PathNode.QuadTo(591.1f, 1145.9f, 575.7f, 1138.6f),
                        PathNode.QuadTo(560.2f, 1131.2f, 532.9f, 1115.3f),
                        PathNode.LineTo(251.9f, 956.3f),
                        PathNode.QuadTo(243.7f, 951.7f, 234.6f, 946.5f),
                        PathNode.QuadTo(218.2f, 937.1f, 204.7f, 928.6f),
                        PathNode.QuadTo(191.2f, 920.1f, 184.2f, 911.5f),
                        PathNode.QuadTo(165.6f, 889.9f, 157.4f, 864.6f),
                        PathNode.QuadTo(152.8f, 851.4f, 151.8f, 834.0f),
                        PathNode.QuadTo(150.8f, 816.5f, 150.8f, 784.2f),
                        PathNode.VerticalTo(475.2f),
                        PathNode.QuadTo(150.8f, 442.9f, 151.8f, 425.0f),
                        PathNode.QuadTo(152.8f, 407.1f, 157.4f, 393.9f),
                        PathNode.QuadTo(165.6f, 367.5f, 184.2f, 347.9f),
                        PathNode.QuadTo(192.7f, 338.4f, 206.2f, 329.4f),
                        PathNode.QuadTo(219.6f, 320.4f, 240.9f, 308.2f),
                        PathNode.LineTo(251.9f, 302.2f),
                        PathNode.LineTo(532.9f, 144.2f),
                        PathNode.LineTo(550.9f, 134.2f),
                        PathNode.QuadTo(566.5f, 125.2f, 580.1f, 118.9f),
                        PathNode.QuadTo(593.7f, 112.6f, 604.3f, 110.6f),
                        PathNode.QuadTo(630.0f, 105.0f, 655.8f, 110.6f),
                        PathNode.Close,
                        PathNode.MoveTo(253.3f, 449.4f),
                        PathNode.VerticalTo(815.5f),
                        PathNode.QuadTo(253.3f, 828.9f, 258.6f, 837.9f),
                        PathNode.QuadTo(263.9f, 846.9f, 277.2f, 854.2f),
                        PathNode.LineTo(602.2f, 1037.2f),
                        PathNode.QuadTo(619.4f, 1047.0f, 629.1f, 1047.5f),
                        PathNode.QuadTo(638.9f, 1048.0f, 654.1f, 1039.6f),
                        PathNode.LineTo(972.9f, 860.2f),
                        PathNode.QuadTo(996.2f, 847.4f, 1002.0f, 837.1f),
                        PathNode.QuadTo(1007.8f, 826.9f, 1007.8f, 800.2f),
                        PathNode.VerticalTo(451.2f),
                        PathNode.QuadTo(1007.8f, 434.6f, 1003.7f, 424.9f),
                        PathNode.QuadTo(999.6f, 415.1f, 987.9f, 408.3f),
                        PathNode.LineTo(658.5f, 221.3f),
                        PathNode.QuadTo(640.7f, 211.5f, 629.9f, 211.5f),
                        PathNode.QuadTo(619.2f, 211.5f, 601.6f, 221.9f),
                        PathNode.LineTo(280.2f, 403.3f),
                        PathNode.QuadTo(263.9f, 412.1f, 258.6f, 421.2f),
                        PathNode.QuadTo(253.3f, 430.2f, 253.3f, 449.4f),
                        PathNode.Close,
                        PathNode.MoveTo(838.3f, 629.2f),
                        PathNode.QuadTo(838.3f, 686.0f, 810.1f, 733.6f),
                        PathNode.QuadTo(781.9f, 781.1f, 734.4f, 809.3f),
                        PathNode.QuadTo(686.8f, 837.5f, 630.0f, 837.5f),
                        PathNode.QuadTo(573.7f, 837.5f, 525.9f, 809.6f),
                        PathNode.QuadTo(478.2f, 781.7f, 450.0f, 733.9f),
                        PathNode.QuadTo(421.8f, 686.0f, 421.8f, 629.2f),
                        PathNode.QuadTo(421.8f, 572.9f, 450.0f, 525.1f),
                        PathNode.QuadTo(478.2f, 477.4f, 525.9f, 449.2f),
                        PathNode.QuadTo(573.7f, 421.0f, 630.0f, 421.0f),
                        PathNode.QuadTo(686.8f, 421.0f, 734.7f, 449.2f),
                        PathNode.QuadTo(782.5f, 477.4f, 810.4f, 525.1f),
                        PathNode.QuadTo(838.3f, 572.9f, 838.3f, 629.2f),
                        PathNode.Close,
                        PathNode.MoveTo(526.3f, 629.2f),
                        PathNode.QuadTo(526.3f, 672.7f, 556.6f, 702.9f),
                        PathNode.QuadTo(587.0f, 733.0f, 630.0f, 733.0f),
                        PathNode.QuadTo(673.5f, 733.0f, 703.7f, 702.9f),
                        PathNode.QuadTo(733.8f, 672.7f, 733.8f, 629.2f),
                        PathNode.QuadTo(733.8f, 586.2f, 703.7f, 555.8f),
                        PathNode.QuadTo(673.5f, 525.5f, 630.0f, 525.5f),
                        PathNode.QuadTo(587.0f, 525.5f, 556.6f, 555.8f),
                        PathNode.QuadTo(526.3f, 586.2f, 526.3f, 629.2f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _settingsMedium!!
    }

private var _settingsMedium: ImageVector? = null

val COUIIcons.Demibold.Settings: ImageVector
    get() {
        if (_settingsDemibold != null) return _settingsDemibold!!
        _settingsDemibold = ImageVector.Builder(
            name = "Settings.Demibold",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1274.4f,
            viewportHeight = 1274.4f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1274.4f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(664.2f, 112.2f),
                        PathNode.QuadTo(675.2f, 114.2f, 689.2f, 120.7f),
                        PathNode.QuadTo(703.2f, 127.2f, 719.2f, 136.2f),
                        PathNode.LineTo(737.2f, 146.2f),
                        PathNode.LineTo(1018.2f, 304.2f),
                        PathNode.QuadTo(1049.2f, 321.2f, 1063.2f, 330.7f),
                        PathNode.QuadTo(1077.2f, 340.2f, 1087.2f, 351.2f),
                        PathNode.QuadTo(1106.2f, 371.2f, 1115.2f, 399.2f),
                        PathNode.QuadTo(1120.2f, 413.2f, 1121.2f, 429.7f),
                        PathNode.QuadTo(1122.2f, 446.2f, 1122.2f, 482.2f),
                        PathNode.VerticalTo(791.2f),
                        PathNode.QuadTo(1122.2f, 827.2f, 1121.2f, 843.2f),
                        PathNode.QuadTo(1120.2f, 859.2f, 1115.2f, 873.2f),
                        PathNode.QuadTo(1106.2f, 900.2f, 1087.2f, 922.2f),
                        PathNode.QuadTo(1079.2f, 932.2f, 1066.2f, 940.2f),
                        PathNode.QuadTo(1053.2f, 948.2f, 1030.2f, 961.2f),
                        PathNode.LineTo(1018.2f, 968.2f),
                        PathNode.LineTo(737.2f, 1127.2f),
                        PathNode.QuadTo(706.2f, 1145.2f, 692.2f, 1151.7f),
                        PathNode.QuadTo(678.2f, 1158.2f, 664.2f, 1160.2f),
                        PathNode.QuadTo(637.2f, 1168.2f, 610.2f, 1160.2f),
                        PathNode.QuadTo(596.2f, 1158.2f, 582.2f, 1151.7f),
                        PathNode.QuadTo(568.2f, 1145.2f, 537.2f, 1127.2f),
                        PathNode.LineTo(256.2f, 968.2f),
                        PathNode.QuadTo(247.2f, 963.2f, 237.2f, 957.2f),
                        PathNode.QuadTo(221.2f, 948.2f, 207.7f, 939.7f),
                        PathNode.QuadTo(194.2f, 931.2f, 187.2f, 922.2f),
                        PathNode.QuadTo(168.2f, 900.2f, 159.2f, 873.2f),
                        PathNode.QuadTo(154.2f, 859.2f, 153.2f, 843.2f),
                        PathNode.QuadTo(152.2f, 827.2f, 152.2f, 791.2f),
                        PathNode.VerticalTo(482.2f),
                        PathNode.QuadTo(152.2f, 446.2f, 153.2f, 429.7f),
                        PathNode.QuadTo(154.2f, 413.2f, 159.2f, 399.2f),
                        PathNode.QuadTo(168.2f, 371.2f, 187.2f, 351.2f),
                        PathNode.QuadTo(196.2f, 341.2f, 209.2f, 332.2f),
                        PathNode.QuadTo(222.2f, 323.2f, 245.2f, 310.2f),
                        PathNode.LineTo(256.2f, 304.2f),
                        PathNode.LineTo(537.2f, 146.2f),
                        PathNode.LineTo(555.2f, 136.2f),
                        PathNode.QuadTo(571.2f, 127.2f, 585.2f, 120.7f),
                        PathNode.QuadTo(599.2f, 114.2f, 610.2f, 112.2f),
                        PathNode.QuadTo(637.2f, 106.2f, 664.2f, 112.2f),
                        PathNode.Close,
                        PathNode.MoveTo(266.2f, 457.2f),
                        PathNode.VerticalTo(821.2f),
                        PathNode.QuadTo(266.2f, 834.2f, 270.7f, 842.2f),
                        PathNode.QuadTo(275.2f, 850.2f, 287.2f, 856.2f),
                        PathNode.LineTo(612.2f, 1039.2f),
                        PathNode.QuadTo(628.2f, 1048.2f, 636.7f, 1048.7f),
                        PathNode.QuadTo(645.2f, 1049.2f, 659.2f, 1041.2f),
                        PathNode.LineTo(977.2f, 862.2f),
                        PathNode.QuadTo(999.2f, 850.2f, 1004.2f, 841.2f),
                        PathNode.QuadTo(1009.2f, 832.2f, 1009.2f, 807.2f),
                        PathNode.VerticalTo(458.2f),
                        PathNode.QuadTo(1009.2f, 443.2f, 1005.7f, 434.7f),
                        PathNode.QuadTo(1002.2f, 426.2f, 992.2f, 420.2f),
                        PathNode.LineTo(663.2f, 233.2f),
                        PathNode.QuadTo(646.2f, 224.2f, 636.7f, 224.2f),
                        PathNode.QuadTo(627.2f, 224.2f, 611.2f, 234.2f),
                        PathNode.LineTo(290.2f, 415.2f),
                        PathNode.QuadTo(275.2f, 423.2f, 270.7f, 431.2f),
                        PathNode.QuadTo(266.2f, 439.2f, 266.2f, 457.2f),
                        PathNode.Close,
                        PathNode.MoveTo(851.2f, 636.2f),
                        PathNode.QuadTo(851.2f, 694.2f, 822.2f, 743.2f),
                        PathNode.QuadTo(793.2f, 792.2f, 744.2f, 821.2f),
                        PathNode.QuadTo(695.2f, 850.2f, 637.2f, 850.2f),
                        PathNode.QuadTo(579.2f, 850.2f, 530.2f, 821.7f),
                        PathNode.QuadTo(481.2f, 793.2f, 452.2f, 743.7f),
                        PathNode.QuadTo(423.2f, 694.2f, 423.2f, 636.2f),
                        PathNode.QuadTo(423.2f, 578.2f, 452.2f, 529.2f),
                        PathNode.QuadTo(481.2f, 480.2f, 530.2f, 451.2f),
                        PathNode.QuadTo(579.2f, 422.2f, 637.2f, 422.2f),
                        PathNode.QuadTo(695.2f, 422.2f, 744.7f, 451.2f),
                        PathNode.QuadTo(794.2f, 480.2f, 822.7f, 529.2f),
                        PathNode.QuadTo(851.2f, 578.2f, 851.2f, 636.2f),
                        PathNode.Close,
                        PathNode.MoveTo(539.2f, 636.2f),
                        PathNode.QuadTo(539.2f, 677.2f, 567.7f, 705.7f),
                        PathNode.QuadTo(596.2f, 734.2f, 637.2f, 734.2f),
                        PathNode.QuadTo(678.2f, 734.2f, 706.7f, 705.7f),
                        PathNode.QuadTo(735.2f, 677.2f, 735.2f, 636.2f),
                        PathNode.QuadTo(735.2f, 595.2f, 706.7f, 566.7f),
                        PathNode.QuadTo(678.2f, 538.2f, 637.2f, 538.2f),
                        PathNode.QuadTo(596.2f, 538.2f, 567.7f, 566.7f),
                        PathNode.QuadTo(539.2f, 595.2f, 539.2f, 636.2f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _settingsDemibold!!
    }

private var _settingsDemibold: ImageVector? = null
